import { pick } from 'lodash'

import { UserRegistrationFormData } from './formTypes'

// These utilities allows us to store form data in local storage during the user registration,
// this way a user can camplete a part of the form and come back later for completition.
// Just for first registration, does not work on update
export const STORAGE_KEY_BASENAME = 'formDraftData'

export const saveDraftToLocalStorage = (
  values: UserRegistrationFormData,
  userId: number
): void => {
  const jsonData = JSON.stringify(values)
  localStorage.setItem(`${STORAGE_KEY_BASENAME}:${userId}`, jsonData)
}

export const deleteDraftFromLocalStorage = (userId: number): void => {
  localStorage.removeItem(`${STORAGE_KEY_BASENAME}:${userId}`)
}

export const restoreDraftFromLocalStorage = (
  userId: number,
  defaultValues: UserRegistrationFormData
): UserRegistrationFormData => {
  const draftJsonData = localStorage.getItem(
    `${STORAGE_KEY_BASENAME}:${userId}`
  )

  if (!draftJsonData) return defaultValues

  try {
    const draftData = JSON.parse(draftJsonData, (key, value) => {
      if (typeof value === 'string') {
        if (
          (value && key === 'company_cciaa_date') ||
          key === 'company_date_start' ||
          key === 'birth_date'
        ) {
          return new Date(value)
        }

        return value
      }

      return value
    })

    // From saved object we take only the keys available in default values
    const draftDataClean = pick(
      draftData,
      Object.keys(defaultValues)
    ) as UserRegistrationFormData

    // returning default values filled with valid keys found from local storage
    return {
      ...defaultValues,
      ...draftDataClean,
    }
  } catch {
    console.error(
      'Draft Error: Unable to obtain draft data from the local storage.'
    )
    return defaultValues
  }
}
